function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.071 5l.707.707-6.364 6.363 6.364 6.365-.707.707L8 12.071 15.071 5z",
  fill: "currentColor"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M15.0711 4.99995L15.7782 5.70706L9.41353 12.0703L15.7782 18.435L15.0711 19.1421L8.00002 12.071L15.0711 4.99995Z' fill='currentColor' /%3E %3C/svg%3E";
export { SvgArrowRight as ReactComponent };